import { useTranslation } from 'react-i18next';
import { motion } from 'motion/react';
import { Upload } from 'lucide-react';

export function VideoUploadPage() {
  const { t } = useTranslation();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-5 px-4 sm:px-6 md:px-8"
    >
      <h1 className="text-lg sm:text-2xl font-semibold">{t('videos.uploadTitle', 'Upload Video')}</h1>

      <div
        className="flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-slate-300 p-12 text-center"
        style={{
          background: 'rgba(255,255,255,0.7)',
          backdropFilter: 'blur(20px)',
        }}
      >
        <Upload size={40} className="text-slate-300 mb-4" />
        <p className="text-sm font-medium text-slate-700">{t('videos.dragDrop', 'Drag and drop your video here')}</p>
        <p className="text-xs text-slate-400 mt-1">{t('videos.formats', 'MP4, MOV, or WebM up to 500MB')}</p>
        <button className="mt-4 rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600 transition-colors">
          {t('videos.selectFile', 'Select File')}
        </button>
      </div>
    </motion.div>
  );
}
